export default __webpack_public_path__ + "static/media/icon--website.a92c7fee.svg";